import { useState, useEffect } from 'react';

const usePageMassAction = (rows = [], uniqueKey = 'id') => {
  const [selected, setSelected] = useState([]);

  const isRowSelected = (row) => {
    const rowValue = row[uniqueKey];
    return selected.includes(rowValue);
  };

  const onRowSelected = (row) => {
    const rowValue = row[uniqueKey];
    if (isRowSelected(row) === true) {
      const newSelected = selected.filter(
        (selectedValue) => selectedValue !== rowValue
      );
      return setSelected(newSelected);
    }
    return setSelected([...selected, rowValue]);
  };

  const onHeaderSelected = (rows) => {
    const areAllSelected = rows.every(isRowSelected);
    if (areAllSelected) {
      return setSelected([]);
    }
    return setSelected(rows.map((row) => row[uniqueKey]));
  };

  const massAction = {
    isRowSelected,
    onRowSelected,
    onHeaderSelected,
    selected,
    setSelected,
  };

  useEffect(() => {
    setSelected([]);
  }, [rows, uniqueKey]);

  return [massAction];
};

export default usePageMassAction;
